import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_3: FaireProductEntity = {
  token: "viverano-3",
  type: "product",
  name: "Elephant Reversible Baby Hooded Towel (Organic Cotton)",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/3aaaa1f2d6287d41138b7b5829281d2aa0b51a8432317e224e13e18ae9ee31ce.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1857,1857,x90,y192,safe&width=720",
  priceDollars: 24.5,
  msrpDollars: 42,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_baby-accessories"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
